<div class="mt-2 d-flex align-items-center flex-column">
  <p class="mt3">{{customText || 'Nenhum registro encontrado.'}}</p>

</div>